module.exports = __webpack_public_path__ + "img/zepto.68a6d523.svg";